import { z } from 'zod'

export const TeamStatusZod = z.enum([
  'IN_RETURN',
  'ASSIGNED',
  'AVAILABLE_IN_LOCATION',
  'AVAILABLE_IN_INSTITUTION',
  'AVAILABLE_IN_REGION',
  'DISSOLVED',
  'ON_BREAK',
  'AVAILABLE_AT_COORDINATES',
])
export type TeamStatus = z.infer<typeof TeamStatusZod>
